import { fetchWithAuth } from '../../../common/utils/apiUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

class IndigenousReserveService {

    getMvtUrlTemplate() {
        return `${API_BASE_URL}/mvt/indigenous-reserves/{z}/{x}/{y}`;
    }

    async getAllIndigenousReservesGeoJson() {
        try {
            const response = await fetchWithAuth(`${API_BASE_URL}/indigenous-reserves/geojson`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return { data };
        } catch (error) {
            console.error('Error fetching indigenous reserves GeoJSON:', error);
            throw error;
        }
    }
}

export default new IndigenousReserveService();